import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";

export default createForm(() => {
    return (
        <form onSubmit={this.props.handleSubmit}>
            <div className="row form-row">
                <div className="col-md-2">
                    <ComponentField
                        getFieldProps={this.props.getFieldProps}
                        componentConfig={this.props.componentConfig}
                        name={this.props.componentConfig.idfield}
                        values={this.props.values}
                        setFieldValue={this.props.setFieldValue}
                        label="Kód"
                    />
                </div>
                <div className="col-md-10">
                    <ComponentField
                        getFieldProps={this.props.getFieldProps}
                        componentConfig={this.props.componentConfig}
                        name="legal_sequence_number"
                        values={this.props.values}
                        setFieldValue={this.props.setFieldValue}
                        label="ID"
                    />
                </div>
            </div>
        </form>
    );
});
